const combineQueryStrings = (...queryStrings: Array<string>): string => {
    const response: Array<string> = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < queryStrings.length; i++) {
        let queryString = queryStrings[i];
        if (typeof queryString === 'string') {
            while (queryString.startsWith('?')) {
                queryString = queryString.slice(1);
            }
            while (queryString.startsWith('&')) {
                queryString = queryString.slice(1);
            }
            while (queryString.endsWith('&')) {
                queryString = queryString.slice(0, queryString.length - 1);
            }
            response.push(queryString);
        }
    }
    return `?${response.join('&')}`;
};

export const getParams = (...queryStrings: Array<string>) => {
    const queryString = combineQueryStrings(...queryStrings);
    return queryString
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key) {
                if (key.includes('columnGroup_')) {
                    const [groupKey, columnKey] = key.split('_');
                    const column = {};
                    column[columnKey] = value
                        ? decodeURIComponent(value)
                        : undefined;
                    params[groupKey] = { ...params[groupKey], ...column };
                } else {
                    params[key] = value ? decodeURIComponent(value) : undefined;
                }
            }
            return params;
        }, {});
};

export const getFilterParams = (...queryStrings: Array<string>) => {
    const queryString = combineQueryStrings(...queryStrings);
    return queryString
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key && key.startsWith('_')) {
                params[key.slice(1)] = value
                    ? decodeURIComponent(value)
                    : undefined;
            }
            return params;
        }, {});
};

export const getNonFilterParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key && !key.startsWith('_')) {
                params[key] = value ? decodeURIComponent(value) : undefined;
            }
            return params;
        }, {});
};



// WEBPACK FOOTER //
// ./src/utils/getParams.ts